import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import SobreMi from "@/pages/SobreMi";
import ServicePage from "@/pages/ServicePage";
import Contacto from "@/pages/Contacto";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import { SERVICES } from "@/data/services";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/sobre-mi" element={<SobreMi />} />
            {SERVICES.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage slug={s.slug} />} />
            ))}
            <Route path="/blog" element={<Navigate to="/" replace />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/aviso-legal" element={<Legal page="aviso-legal" />} />
            <Route path="/politica-privacidad" element={<Legal page="politica-privacidad" />} />
            <Route path="/politica-cookies" element={<Legal page="politica-cookies" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/acceso" element={<AdminLogin />} />
          <Route path="/panel" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
